import 'bootstrap';

const recipeForm = document.querySelector('[data-recipe-form]');
if (recipeForm) {
  const container = recipeForm.querySelector('[data-recipe-rows]');
  const prototype = container.querySelector('[data-recipe-row]').cloneNode(true);
  const indexes = [...container.querySelectorAll('select[name]')]
    .map((control) => Number.parseInt(control.name.match(/materials\[(\d+)\]/)?.[1] || '0', 10));
  let nextIndex = Math.max(0, ...indexes) + 1;
  recipeForm.querySelector('[data-add-recipe-row]').addEventListener('click', () => {
    const row = prototype.cloneNode(true);
    row.querySelectorAll('input,select,textarea').forEach((control) => {
      control.name = control.name.replace(/materials\[\d+\]/, `materials[${nextIndex}]`);
      control.id = control.id.replace(/materials-\d+-/, `materials-${nextIndex}-`);
      control.value = control.tagName === 'SELECT' ? '' : (control.inputMode === 'decimal' ? '0' : '');
    });
    row.querySelectorAll('label').forEach((label) => {
      label.htmlFor = label.htmlFor.replace(/materials-\d+-/, `materials-${nextIndex}-`);
    });
    nextIndex += 1;
    container.appendChild(row);
  });
  container.addEventListener('click', (event) => {
    if (event.target.matches('[data-remove-recipe-row]')) event.target.closest('[data-recipe-row]').remove();
  });
}

document.querySelectorAll('[data-auto-submit]').forEach((element) => {
  element.addEventListener('change', () => element.form?.requestSubmit());
});

const activeSidebarLink = document.querySelector('.app-sidebar-nav [aria-current="page"]');
if (activeSidebarLink) {
  requestAnimationFrame(() => activeSidebarLink.scrollIntoView({block: 'nearest'}));
}

const posCart = document.querySelector('[data-pos-cart]');
if (posCart) {
  const rowsContainer = posCart.querySelector('[data-cart-rows]');
  const rowTemplate = posCart.querySelector('[data-cart-row-template]');
  const emptyState = posCart.querySelector('[data-cart-empty]');
  const addButton = document.querySelector('[data-add-cart-row]');
  const shippingInput = document.querySelector('[data-cart-shipping]');
  const variantPrices = JSON.parse(posCart.dataset.variantPrices || '{}');
  const rowIndexes = [...rowsContainer.querySelectorAll('[data-cart-row]')]
    .map((row) => Number.parseInt(row.dataset.cartIndex, 10))
    .filter(Number.isInteger);
  let nextRowIndex = rowIndexes.length ? Math.max(...rowIndexes) + 1 : 0;

  const decimalUnits = (value, scale) => {
    const normalized = String(value || '').trim().replace(',', '.');
    if (!/^\d+(\.\d+)?$/.test(normalized)) return 0n;
    const [whole, fraction = ''] = normalized.split('.');
    const decimals = fraction.padEnd(scale, '0').slice(0, scale);
    return (BigInt(whole) * (10n ** BigInt(scale))) + BigInt(decimals || '0');
  };

  const formatCents = (value) => {
    const negative = value < 0n;
    const absolute = negative ? -value : value;
    const digits = absolute.toString().padStart(3, '0');
    const integer = digits.slice(0, -2).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const cents = digits.slice(-2);
    return `${negative ? '-' : ''}R$ ${integer},${cents}`;
  };

  const rows = () => [...rowsContainer.querySelectorAll('[data-cart-row]')];

  const refreshProductAvailability = () => {
    const selected = rows()
      .map((row) => row.querySelector('[data-cart-product]')?.value)
      .filter(Boolean);
    rows().forEach((row) => {
      const select = row.querySelector('[data-cart-product]');
      [...select.options].forEach((option) => {
        option.disabled = option.value !== select.value && selected.includes(option.value);
      });
    });
  };

  const updateTotals = () => {
    let subtotalCents = 0n;
    rows().forEach((row) => {
      const quantity = decimalUnits(row.querySelector('[data-cart-quantity]')?.value, 3);
      const priceCents = decimalUnits(row.querySelector('[data-cart-price]')?.value, 2);
      const discountCents = decimalUnits(row.querySelector('[data-cart-discount]')?.value, 2);
      const lineCents = ((quantity * priceCents) / 1000n) - discountCents;
      subtotalCents += lineCents;
      row.querySelector('[data-cart-line-total]').textContent = formatCents(lineCents);
    });
    const shippingCents = decimalUnits(shippingInput?.value, 2);
    document.querySelector('[data-cart-subtotal]').textContent = formatCents(subtotalCents);
    document.querySelector('[data-cart-shipping-total]').textContent = formatCents(shippingCents);
    document.querySelector('[data-cart-total]').textContent = formatCents(subtotalCents + shippingCents);
    emptyState.classList.toggle('d-none', rows().length > 0);
    refreshProductAvailability();
  };

  addButton?.addEventListener('click', () => {
    const html = rowTemplate.innerHTML.replaceAll('__INDEX__', String(nextRowIndex));
    nextRowIndex += 1;
    rowsContainer.insertAdjacentHTML('beforeend', html);
    const addedRow = rows().at(-1);
    addedRow?.querySelector('[data-cart-product]')?.focus();
    updateTotals();
  });

  rowsContainer.addEventListener('click', (event) => {
    const removeButton = event.target.closest('[data-remove-cart-row]');
    if (!removeButton) return;
    removeButton.closest('[data-cart-row]')?.remove();
    updateTotals();
  });

  rowsContainer.addEventListener('change', (event) => {
    const product = event.target.closest('[data-cart-product]');
    if (product) {
      const price = product.closest('[data-cart-row]')?.querySelector('[data-cart-price]');
      if (price && price.value === '' && variantPrices[product.value]) {
        price.value = variantPrices[product.value];
      }
    }
    updateTotals();
  });
  rowsContainer.addEventListener('input', updateTotals);
  shippingInput?.addEventListener('input', updateTotals);
  updateTotals();
}
document.querySelectorAll('[data-consumption-editor]').forEach((editor) => {
    const rows = editor.querySelector('[data-consumption-rows]');
    editor.querySelector('[data-add-consumption]').addEventListener('click', () => {
        const index = editor.dataset.nextIndex;
        editor.dataset.nextIndex = String(Number(index) + 1);
        const markup = editor.querySelector('[data-consumption-template]').innerHTML.replaceAll('__INDEX__', index);
        rows.insertAdjacentHTML('beforeend', markup);
    });
    editor.addEventListener('click', (event) => {
        const remove = event.target.closest('[data-remove-consumption]');
        if (remove) remove.closest('[data-consumption-row]').remove();
    });
});

document.querySelectorAll('[data-sale-editor], [data-package-editor]').forEach((editor) => {
    const sale = editor.hasAttribute('data-sale-editor');
    const rows = editor.querySelector(sale ? '[data-sale-rows]' : '[data-package-rows]');
    let next = Math.max(-1, ...Array.from(rows.querySelectorAll('[name]')).map((field) =>
        Number(field.name.match(/\[(\d+)\]/)?.[1] ?? -1))) + 1;
    editor.querySelector(sale ? '[data-add-sale-line]' : '[data-add-package]').addEventListener('click', () => {
        rows.insertAdjacentHTML('beforeend', editor.querySelector(sale ? '[data-sale-template]' : '[data-package-template]')
            .innerHTML.replaceAll('__INDEX__', String(next++)));
    });
    editor.addEventListener('click', (event) => {
        const button = event.target.closest(sale ? '[data-remove-sale-line]' : '[data-remove-package]');
        if (button) button.closest(sale ? '[data-sale-line]' : '[data-package-row]').remove();
    });
    if (sale) {
        const suggest = async (row) => {
            const variant = row.querySelector('[data-sale-variant]').value;
            const channel = document.querySelector('#sale-channel').value;
            const location = document.querySelector('#sale-location').value;
            if (!variant || !channel || !location) return;
            const selected = `${variant}/${channel}/${location}`;
            row.dataset.selection = selected;
            const url = new URL(editor.dataset.suggestionUrl, window.location.origin);
            url.search = new URLSearchParams({variant, channel, location}).toString();
            try {
                const response = await fetch(url, {headers: {'Accept': 'application/json'}});
                if (!response.ok) throw new Error('suggestion');
                const data = await response.json();
                if (row.dataset.selection !== selected) return;
                const price = row.querySelector('[data-sale-price]');
                if (price.value === '' && data.price !== null) price.value = data.price;
                row.querySelector('[data-sale-stock]').textContent = `Disponível para venda: ${data.stock.available} · reservado: ${data.stock.reserved} · físico: ${data.stock.physical}`;
            } catch {
                row.querySelector('[data-sale-stock]').textContent = 'Não foi possível consultar agora. Informe o preço; o estoque será validado ao confirmar.';
            }
        };
        editor.addEventListener('change', (event) => {
            if (event.target.matches('[data-sale-variant]')) suggest(event.target.closest('[data-sale-line]'));
        });
        ['#sale-channel', '#sale-location'].forEach((selector) => {
            document.querySelector(selector)?.addEventListener('change', () => rows.querySelectorAll('[data-sale-line]').forEach(suggest));
        });
        rows.querySelectorAll('[data-sale-line]').forEach(suggest);
    }
});

document.querySelectorAll('[data-sale-board]').forEach((board) => {
    let dragged = null;
    board.addEventListener('dragstart', (event) => { dragged = event.target.closest('[data-sale-card]'); });
    board.addEventListener('dragend', () => { dragged = null; });
    board.querySelectorAll('[data-sale-stage]').forEach((column) => {
        column.addEventListener('dragover', (event) => { if (dragged) event.preventDefault(); });
        column.addEventListener('drop', (event) => {
            event.preventDefault();
            if (!dragged) return;
            const operation = {AWAITING_PRODUCTION: 'confirm', PREPARING: 'confirm', READY: 'pack',
                SHIPPED: 'ship', DELIVERED: 'deliver', AWAITING_PAYMENT: 'deliver', COMPLETED: 'payment', CANCELLED: 'cancel'}[column.dataset.saleStage];
            if (!operation || column.dataset.saleStage === dragged.closest('[data-sale-stage]').dataset.saleStage) {
                window.location.assign(dragged.dataset.detailUrl);
            } else {
                window.location.assign(dragged.dataset.actionBase.replace(/\/$/, '') + '/' + operation);
            }
        });
    });
});

// Preserve entered values on validation errors; never auto-save inventory or financial operations.
let unsavedForm = null;
document.querySelectorAll('form').forEach((form) => {
  if ((form.method || 'get').toLowerCase() !== 'post') return;
  const key = document.createElement('input');
  key.type = 'hidden'; key.name = '_submission_key';
  key.value = [...crypto.getRandomValues(new Uint8Array(32))].map((byte) => byte.toString(16).padStart(2, '0')).join('');
  form.append(key);
  const initiallyDisabled = new Set([...form.querySelectorAll('button[type="submit"],input[type="submit"]')].filter((button) => button.disabled));
  let sending = false;
  form.addEventListener('input', () => { unsavedForm = form; });
  form.addEventListener('change', () => { unsavedForm = form; });
  form.addEventListener('submit', (event) => {
    if (event.defaultPrevented) return;
    if (sending) { event.preventDefault(); return; }
    sending = true;
    if (unsavedForm === form) unsavedForm = null;
    form.setAttribute('aria-busy', 'true');
    // Preserve submitter names/values used by actions; disabling before serialization would omit them.
    queueMicrotask(() => form.querySelectorAll('button[type="submit"],input[type="submit"]').forEach((button) => { button.disabled = true; }));
  });
  window.addEventListener('pageshow', () => {
    sending = false; form.removeAttribute('aria-busy');
    form.querySelectorAll('button[type="submit"],input[type="submit"]').forEach((button) => { button.disabled = initiallyDisabled.has(button); });
  });
});
window.addEventListener('beforeunload', (event) => {
  if (!unsavedForm) return;
  event.preventDefault(); event.returnValue = '';
});

document.querySelectorAll('#company-import-review').forEach((form) => {
  form.addEventListener('click', (event) => {
    const add = event.target.closest('[data-import-add]');
    if (add) {
      const section = add.closest('[data-import-sheet]');
      section.querySelector('[data-import-rows]').append(section.querySelector('template').content.cloneNode(true));
      section.open = true;
    }
    const remove = event.target.closest('[data-import-remove]');
    if (remove) remove.closest('[data-import-row]').remove();
  });
  form.addEventListener('submit', () => {
    const payload = {};
    form.querySelectorAll('[data-import-sheet]').forEach((section) => {
      payload[section.dataset.importSheet] = [...section.querySelectorAll('[data-import-rows] [data-import-row]')].map((row) => {
        const values = {};
        row.querySelectorAll('[data-import-field]').forEach((field) => { values[field.dataset.importField] = field.value; });
        return values;
      });
    });
    form.querySelector('#company-import-payload').value = JSON.stringify(payload);
  });
});
